import { useState } from "react";

import { CalculatorIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import { useQuoteCalculatorAccess } from "../../../data/useQuoteCalculator";
import QuoteCalculatorModal from "./QuoteCalculatorModal";

/**
 * Topbar "Get Quote" button. Shown only when the customer has leads or is a call centre, the role
 * can open them and see prices, and this Wilma is connected to its widget. It lives in the topbar
 * rather than on the Leads page alone because a quote is asked for mid-call, from whatever page
 * is open.
 */
export default function QuoteCalculatorButton() {
  const { t } = useTranslation("common");
  const { show } = useQuoteCalculatorAccess("QuoteCalculatorButton");
  const [open, setOpen] = useState(false);

  if (!show) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={t("Get Quote")}
        className="relative inline-flex items-center gap-x-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
      >
        <CalculatorIcon className="h-5 w-5" aria-hidden="true" />
        <span className="hidden md:inline">{t("Get Quote")}</span>
      </button>
      {open && <QuoteCalculatorModal open={open} setOpen={setOpen} />}
    </>
  );
}
